import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import BlankPagePage from "./pages/BlankPagePage";
import DevicePage from "./pages/DevicePage";
import SignInPage from "./pages/SignInPage";
import ProtectedRoute from "./helper/ProtectedRoute";
import GuestRoute from "./helper/GuestRoute";
import ReportPage from "./pages/ReportPage";
import ReporterPage from "./pages/ReporterPage";
import BotPage from "./pages/BotPage";
import SendMessagePage from "./pages/SendMessagePage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route
          path="/login"
          element={
            <GuestRoute>
              <SignInPage />
            </GuestRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <ProtectedRoute>
              <DevicePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <ReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reporters"
          element={
            <ProtectedRoute>
              <ReporterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bots"
          element={
            <ProtectedRoute>
              <BotPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/send-message"
          element={
            <ProtectedRoute>
              <SendMessagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blank-page"
          element={
            <ProtectedRoute>
              <BlankPagePage />
            </ProtectedRoute>
          }
        />
        {/* Redirect from "/" to "/devices" */}
        <Route
          path="/"
          element={<Navigate to="/devices" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
